import React from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import {GlobalConstants} from "../../globals/GlobalConstants";
import '../../styles/AccumRecalc.css'
import {fetchAuthSession} from "aws-amplify/auth";
import Autocomplete from "@mui/material/Autocomplete";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import {refreshToken} from "../../globals/GlobalFunctions";
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';


//axios.defaults.headers.common['Authorization'] = `Bearer ${}`;

function AccumRecalculator() {
    const [currentDB, setCurrentDB] = React.useState("CoastalAdmin");
    const [validationError, setValidationError] = React.useState(false);
    const [validationText, setValidationText] = React.useState("");
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [loading, setLoading] = React.useState(false);

    const onDBChange = React.useCallback((e: any, newDB: any) => setCurrentDB(newDB.id), []);


    const handleValidationClose = () => {
        setValidationError(false);
    }

    let token = localStorage.getItem('jwt');
    //console.log('jwt', token);

    const recalcAccums = async () => {
        refreshToken();
        setLoading(true);
        const response =
            await axios
                .post(
                    localStorage.getItem('baseURL') + 'accumulator/recalculateaccumulators',
                    JSON.stringify(currentDB),
                    {headers: {'Authorization': `Bearer ${token}`, "Content-Type": "application/json"}
                    }
                ).then(() => {
                    setLoading(false);
                    setSuccessAlert(true);
                }).catch((error) => {
                    setLoading(false);
                    setValidationText(error.response.request.responseText);
                    setValidationError(true);
                });
    }

    return (
        <div className="pageWrap">
            <Stack spacing={3} direction="row">
            {/*<Button variant="contained" onClick={getUsers}>Get Users</Button>*/}
                <LoadingButton className="buttonz" variant="contained" onClick={recalcAccums}loading={loading} loadingPosition="start"
                               startIcon={<CurrencyExchangeIcon />}>Recalculate Accums</LoadingButton>
            </Stack>
            <Dialog
                open={validationError}
                onClose={handleValidationClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                    {"Validation Error"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {validationText}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleValidationClose}>OK</Button>
                </DialogActions>
            </Dialog>
            {successAlert ? <Alert className="accumAlertStyles" severity='success' onClose={() => setSuccessAlert(false)} variant="filled">
                <AlertTitle>Success!</AlertTitle>
                Accum Recalculation Successful!
            </Alert> : <></> }
            <Stack spacing={5} direction="row" className="buttonBarAccumRecalc">
                <Autocomplete
                    className="dbContractSelectAccumRecalc"
                    size={"small"}
                    disablePortal
                    disableClearable
                    options={GlobalConstants.VBA_DB}
                    value={GlobalConstants.VBA_DB.find(option => option.id === currentDB) || null}
                    sx={{ width: 150 }}
                    defaultValue={GlobalConstants.VBA_DB[1]}
                    renderInput={(params) => <TextField {...params}  />}
                    onChange={onDBChange}
                />
            </Stack>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    )
}

export default React.memo(AccumRecalculator);